"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isClicking = isClicking;
function isClicking(prevClick, lastClick) {
    return lastClick && (!prevClick || prevClick.time !== lastClick.time);
}
//# sourceMappingURL=is_clicking.js.map